export default [
  {
    field: 'dataCriacao',
    id: 'dataCriacao',
    label: 'Data',
    minWidth: 10,
  },
  {
    field: 'pergunta',
    id: 'pergunta',
    label: 'Pergunta',
    minWidth: 50,
    align: 'left',
  },
  {
    field: 'resposta',
    id: 'resposta',
    label: 'Resposta',
    minWidth: 100,
    maxWidth: 300,
    align: 'left',
  },
  {
    field: 'menu',
    id: 'menu',
    subfield: 'nome',
    label: 'Menu',
    minWidth: 50,
    align: 'left',
  },
  {
    field: 'uf',
    id: 'uf',
    subfield: 'sigla',
    label: 'UF',
    minWidth: 50,
    align: 'left',
  },
  {
    field: 'perfilUsuario',
    id: 'perfilUsuario',
    subfield: 'nome',
    label: 'Usuário',
    minWidth: 50,
    align: 'left',
  },
  {
    field: 'status',
    id: 'status',
    label: 'Ações',
    minWidth: 100,
    maxWidth: 100,
    align: 'left',
  },
]